import coreRoutes from '@glittr/frontend-core/src/routes';
import Home from './views/pages/index.vue';

export default {
  mode: 'history',
  base: process.env!.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    ...coreRoutes,
    {
      path: '/:tenant/:workspace',
      name: 'dashboard',
      redirect: '/:tenant/:workspace/learningUnits',
    },
    {
      path: '/:tenant/:workspace/learningUnits',
      name: 'learning-units',
      component: () => import('./views/pages/app/learningUnits/list.vue'),
    },
    {
      path: '/:tenant/:workspace/learningUnits/create',
      name: 'learning-units-detail-create',
      component: () => import('./views/pages/app/learningUnits/detailEdit.vue'),
    },
    {
      path: '/:tenant/:workspace/learningUnits/:learningUnitId/edit',
      name: 'learning-units-detail-edit',
      component: () => import('./views/pages/app/learningUnits/detailEdit.vue'),
    },
    {
      path: '/:tenant/:workspace/users/tags',
      name: 'tags',
      component: () => import('./views/pages/app/tags/tags.vue'),
    },
  ],
};
